"use strict";

exports.__esModule = true;
exports.default = pick;

function pick(object, keys) {
  return keys.reduce(function (obj, key) {
    if (typeof object[key] !== 'undefined') {
      obj[key] = object[key];
    }

    return obj;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/lib/utils/pick.js
// module id = 789
// module chunks = 162841849815751